import { getRouterContext, registerHook } from 'hybridly'
import { t } from '@/application/i18n'

const pageTitleOverride = ref<string | null>(null)
const pageTitleLink = ref<string | null>(null)

export function usePageTitle() {
	const defaultTitle = ref<string>('')

	function updateDefaultTitle() {
		const component = getRouterContext()?.view.component || ''
		defaultTitle.value = t(`page.${component.replace('/', '_')}.meta_title`)
	}

	updateDefaultTitle()

	registerHook('navigated', () => {
		updateDefaultTitle()
	})

	const pageTitle = computed(() => pageTitleOverride.value ?? defaultTitle.value)

	useHead({ title: pageTitle })

	return {
		pageTitle: readonly(pageTitle),
		pageTitleLink: readonly(pageTitleLink),
	}
}

export function setPageTitle(title: string, link?: string) {
	pageTitleOverride.value = title
	pageTitleLink.value = link ?? null
}
